import React, { useEffect, useState } from 'react';
import Radio from '../../../../Radio/Radio';
import ActionButtons from './ActionButtons';
import { useQueryBuilder } from '../context/QueryBuilderContext';
import {
  ASSET_PRIVACY_KEY,
  FILTER_OPERATORS,
  PRIVACY_FILTER_OPTIONS,
  PRIVACY_FILTER_VALUES,
} from '../../../utils/constants';

interface PrivacyFilterDropdownProps {
  closeDropdown: () => void;
}

const derivePrivacySelection = (existing: Record<string, any> | null): string => {
  if (!existing) return PRIVACY_FILTER_VALUES.ALL;
  const value = existing[FILTER_OPERATORS.EQUALS];
  if (value === PRIVACY_FILTER_VALUES.PUBLIC || value === PRIVACY_FILTER_VALUES.RESTRICTED) {
    return value;
  }
  return PRIVACY_FILTER_VALUES.ALL;
};

const PrivacyFilterDropdown: React.FC<PrivacyFilterDropdownProps> = ({ closeDropdown }) => {
  const { setCondition, removeCondition, getConditionValue } = useQueryBuilder();
  const [selected, setSelected] = useState<string>(PRIVACY_FILTER_VALUES.ALL);

  useEffect(() => {
    const existing = getConditionValue(ASSET_PRIVACY_KEY) as Record<string, any> | null;
    setSelected(derivePrivacySelection(existing));
  }, []);

  const clearAll = () => {
    setSelected(PRIVACY_FILTER_VALUES.ALL);
    removeCondition(ASSET_PRIVACY_KEY);
    closeDropdown();
  };

  const applyFilter = () => {
    if (selected === PRIVACY_FILTER_VALUES.PUBLIC) {
      setCondition(ASSET_PRIVACY_KEY, FILTER_OPERATORS.EQUALS, PRIVACY_FILTER_VALUES.PUBLIC);
    } else if (selected === PRIVACY_FILTER_VALUES.RESTRICTED) {
      setCondition(ASSET_PRIVACY_KEY, FILTER_OPERATORS.EQUALS, PRIVACY_FILTER_VALUES.RESTRICTED);
    } else {
      removeCondition(ASSET_PRIVACY_KEY);
    }
    closeDropdown();
  };

  return (
    <div className="PrivacyFilter" data-test-id="am-v2-privacy-filter-dropdown">
      <div className="PrivacyFilter__radio-list">
        {PRIVACY_FILTER_OPTIONS.map((option) => (
          <Radio
            key={option.id}
            name="am-v2-asset-privacy"
            value={option.id}
            label={option.name}
            checked={selected === option.id}
            onChange={() =>
              option.id === PRIVACY_FILTER_VALUES.ALL
                ? clearAll()
                : setSelected(option.id)
            }
            testId={`am-v2-privacy-option-${option.id}`}
            version="v2"
          />
        ))}
      </div>

      <ActionButtons
        closeDropdown={closeDropdown}
        clearAll={clearAll}
        applyFilter={applyFilter}
        disabled={selected === PRIVACY_FILTER_VALUES.ALL}
      />
    </div>
  );
};

export default PrivacyFilterDropdown;
